import { render } from "./DetailTicket.vue?vue&type=template&id=6a0d270e"
import script from "./DetailTicket.vue?vue&type=script&lang=js"
export * from "./DetailTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__